import openPositionsSlice from './slice';

export default openPositionsSlice.reducer;
